import type { GeoLocation } from 'components/GeoLocationComponent/GeoLocationComponent';
import type {
  CustomEventActionInput,
  CustomEventCategory,
  CustomEventSeverity,
  CustomEventStatus,
} from 'hooks/customEvents/useCustomEvents';
import { formatLabel } from './EventListItem';

export type EventFormValues = {
  name: string;
  category: CustomEventCategory;
  severity: CustomEventSeverity;
  status: CustomEventStatus;
  summary: string;
  description: string;
  startDatetime?: Date;
  expectedEndDatetime?: Date;
  aorIds: string[];
  location?: GeoLocation;
  resourceSetIds: string[];
  actions: {
    name: string;
    description: string;
    severity: CustomEventActionInput['severity'];
    poc: string | null;
  }[];
};

export const toOptions = (values: string[]) =>
  values.map((value) => ({ value, label: formatLabel(value) }));
